import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'scanner/:country',
    loadComponent: () => import('./views/public/invoice-scanner/invoice-scanner.component').then( m => m.InvoiceScannerComponent )},
  { path: '**', redirectTo: 'scanner/CL' }
];
